'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _player = require('clappr/src/components/player');

var _player2 = _interopRequireDefault(_player);

var _events = require('overrides/clappr/base/events');

var _events2 = _interopRequireDefault(_events);

var _log = require('clappr/src/plugins/log');

var _log2 = _interopRequireDefault(_log);

var _clapprZepto = require('clappr-zepto');

var _clapprZepto2 = _interopRequireDefault(_clapprZepto);

var _crossDomainUtils = require('cross-domain-utils');

require('console-browserify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPlayerInIframe = (0, _crossDomainUtils.isIframe)(window);

var Player = function (_BasePlayer) {
    _inherits(Player, _BasePlayer);

    function Player(options) {
        _classCallCheck(this, Player);

        // Set default options
        var defaultOptions = {
            width: isPlayerInIframe ? null : '640',
            height: isPlayerInIframe ? null : '360',
            debug: window.location.hash === '#abrakadabra',
            parent: null,
            position: 'top-right',
            persistConfig: false,
            disableKeyboardShortcuts: true,
            useHardwareVideoDecoder: true,
            playbackNotSupportedMessage: 'Your browser is not supported <br><a href="https://help.angelcam.com/general-guides-and-info/considering-angelcam/browser-and-platform-compatibility-list" target="_blank" style="font-size: 13px;">learn more</a>',
            playback: {
                hlsjsConfig: {
                    maxSeekHole: 10,
                    defaultAudioCodec: 'mp4a.40.2'
                },
                playInline: true,
                crossOrigin: 'anonymous'
            }
        };
        options = _clapprZepto2.default.extend(defaultOptions, options);
        if (options.debug) {
            _log2.default.setLevel(0);
        }

        // Special hack for broadcasting with timelock: when the streaming ends, reload the page
        // so the playback ends and we get the "come back later" error message from server.
        if (options.endtime) {
            setTimeout(function () {
                location.reload();
            }, options.endtime * 1000);
        }

        return _possibleConstructorReturn(this, (Player.__proto__ || Object.getPrototypeOf(Player)).call(this, options));
    }

    _createClass(Player, [{
        key: '_addEventListeners',
        value: function _addEventListeners() {
            var _this2 = this;

            // Fix: when options changed & mute is true, mute playback
            this.listenTo(this.core, _events2.default.CORE_OPTIONS_CHANGE, function () {
                return _this2.options.mute && _this2.mute();
            });
            return _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), '_addEventListeners', this).call(this);
        }
    }, {
        key: '_addContainerEventListeners',
        value: function _addContainerEventListeners() {
            _get(Player.prototype.__proto__ || Object.getPrototypeOf(Player.prototype), '_addContainerEventListeners', this).call(this);
            var container = this.core.mediaControl.container;
            if (container) {
                this.listenTo(container, _events2.default.CONTAINER_RATEUPDATE, this._onPlaybackRateChange);
            }
            return this;
        }
    }, {
        key: '_onPlaybackRateChange',
        value: function _onPlaybackRateChange(rate) {
            this.trigger(_events2.default.PLAYER_PLAYBACK_RATE, rate);
        }

        /**
         * Set playback rate
         * @param {Float} Playback rate, 1.0 is default 2.0 is 2x faster ...
         * @return {Player} itself
         */

    }, {
        key: 'setPlaybackRate',
        value: function setPlaybackRate(rate) {
            if (_typeof(this.core.mediaControl.container.playback) !== undefined && this.core.getCurrentPlayback().name !== 'flashls') {
                this.core.mediaControl.container.playback.setPlaybackRate(rate);
            }
            return this;
        }

        /**
         * Return name of current playback
         * Used for CRA when determing if FF is available
         * @return {String}
         */

    }, {
        key: 'getCurrentPlaybackName',
        value: function getCurrentPlaybackName() {
            if (_typeof(this.core.mediaControl.container.playback) !== undefined) {
                return this.core.getCurrentPlayback().name;
            }
            return null;
        }
    }]);

    return Player;
}(_player2.default);

exports.default = Player;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/components/player.js
// module id = 131
// module chunks = 0